<template>
  <label :for="id" class="label flex">
    <span v-html="label" :class="cutoffLabel ? 'truncate' : ''" />

    <Tippy :content="tippy" class="flex items-start">
      <InformationCircle class="ml-2 inline-block w-3 h-3" />
    </Tippy>
  </label>
</template>

<script>
import InformationCircle from '@/assets/svg/icons/information-circle.svg?inline'
import Tippy from '@/components/Tippy'

export default {
  components: { InformationCircle, Tippy },

  props: {
    label: { type: String, required: true },
    tippy: { type: String, default: null },
    id: { type: String, default: null },
    cutoffLabel: { type: Boolean, default: false },
  },
}
</script>

<style lang="scss" scoped>
.form-input {
  min-width: 10rem;
}
</style>
